import { Box } from "rebass";
import Close from "../../../../icons/Close";
const AlertCloseButton = ({ sx, onClick, iconStyle, visibleButton }) => {
  return (
    <Box
      sx={{
        display: visibleButton ? "inline-block" : "none",
        backgroundColor: "#FFFFFF",
        position: "absolute",
        left: "16px",
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        marginRight: "5px",
        zIndex: 1,
        ...sx,
      }}
      width={[18, 15]}
      height={[18, 15]}
      onClick={onClick}
    >
      <Close
        style={{
          width: "100%",
          height: "100%",
          ...iconStyle,
        }}
      />
    </Box>
  );
};

AlertCloseButton.defaultProps = {
  sx: {},
  visibleButton: false,
  onClick: () => {},
};

export default AlertCloseButton;
